import t from "./RichText.vue2.js";
import { openBlock as o, createElementBlock as r, createElementVNode as n } from "vue";
/* empty css              */
import c from "../../_virtual/_plugin-vue_export-helper.js";
const i = ["id"];
function p(e, a, d, m, s, l) {
  return o(), r("div", null, [
    n("textarea", { id: e.id }, null, 8, i)
  ]);
}
const $ = /* @__PURE__ */ c(t, [["render", p]]);
export {
  $ as default
};
